import styled from 'styled-components'

export const StyledNewsSearchById = styled.div``
